export type {
  AppConfig,
  Auth0Config,
  AuthConfig,
  AuthProviderName,
  ConfigSource,
  GoogleAuthConfig,
  PaymentConfig,
  PaymentEnvironment,
} from "./types";
export { PaymentProviderName, paymentProviderLabel } from "./types";
export { BackendConfigSource } from "./sources/backend";
export { EnvConfigSource } from "./sources/env";
export { configKey, useConfig } from "./provider";

import type { AppConfig, ConfigSource } from "./types";
import { BackendConfigSource } from "./sources/backend";
import { EnvConfigSource } from "./sources/env";

export function createConfigSource(): ConfigSource {
  const which = (import.meta.env.VITE_PORTAL_CONFIG_SOURCE ?? "backend") as string;
  if (which === "env") {
    return new EnvConfigSource();
  }
  const url = import.meta.env.VITE_PORTAL_CONFIG_URL ?? "/api/portal/config";
  return new BackendConfigSource({ url });
}

export async function loadAppConfig(source: ConfigSource = createConfigSource()): Promise<AppConfig> {
  return source.load();
}
